import { Checkbox, DatePicker, Input } from 'components/atoms';

export const errorsMap = {
  number: 'Este campo debe ser numerico',
  string: 'Este campo debe ser una cadena de texto',
  date: 'Este campo debe ser una fecha',
  boolean: undefined,
};

export const regExp = {
  number: new RegExp('^[0-9]*$'),
  string: undefined,
  date: undefined,
  boolean: undefined,
};

export const inputComponent = {
  number: Input,
  string: Input,
  date: DatePicker,
  boolean: Checkbox,
};
